module.exports = __webpack_public_path__ + "img/bumanyi.d8447fbe.png";